// KnowLedgeRoboEnqueteDto.js

class KnowLedgeRoboEnqueteDto {
    actionType = String();
    actionDetail = String();
    qaCategory = String();
    actionDate = String();
    sessionId = String();
    destinationOrgId = String();
    destinationOrgDomain = String();
    destinationOrgName = String();
    destinationPrjId = String();
    destinationPrjName = String();
    orgActionId = String();
    orgActionDomain = String();
    orgActionName = String();
    prjActionId = String();
    prjActionName = String();
    userActionId = String();
    userActionEmail = String();
    userActionName = String();
    operationScreen = String();
    enqueteResult = String();
    enqueteFor = String();
    tagGroup = String();
    selectTag = String();
    aiChatInquiryText = String();
    aiChatAnswerText = String();
    searchCondition = String();

    constructor(data) {
        this.actionType = data.actionType;
        this.actionDetail = data.actionDetail;
        this.qaCategory = data.qaCategory;
        this.actionDate = data.actionDate;
        this.sessionId = data.sessionId;
        this.destinationOrgId = data.destinationOrgId;
        this.destinationOrgDomain = data.destinationOrgDomain;
        this.destinationOrgName = data.destinationOrgName;
        this.destinationPrjId = data.destinationPrjId;
        this.destinationPrjName = data.destinationPrjName;
        this.orgActionId = data.orgActionId;
        this.orgActionDomain = data.orgActionDomain;
        this.orgActionName = data.orgActionName;
        this.prjActionId = data.prjActionId;
        this.prjActionName = data.prjActionName;
        this.userActionId = data.userActionId;
        this.userActionEmail = data.userActionEmail;
        this.userActionName = data.userActionName;
        this.operationScreen = data.operationScreen;
        this.enqueteResult = data.enqueteResult;
        this.enqueteFor = data.enqueteFor;
        this.tagGroup = data.tagGroup;
        this.selectTag = data.selectTag;
        this.aiChatInquiryText = data.aiChatInquiryText;
        this.aiChatAnswerText = data.aiChatAnswerText;
        this.searchCondition = data.searchCondition;
    }
}

export default KnowLedgeRoboEnqueteDto;
